import React from "react";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";
import Typograph from "@material-ui/core/Typography";

const CheckpointProgressBar = ({ data }) => {
  const { checkpoints, progress, progressUpperLabel, progressLowerLabel } =
    data;
  return (
    <MainContainer>
      <ProgressBarContainer>
        <ProgressLabelContainer>
          <Typograph variant="subtitle2">{progressUpperLabel}</Typograph>
          <Typograph variant="subtitle2">{progressLowerLabel}</Typograph>
        </ProgressLabelContainer>
        <ProgressBar progress={progress} />
        {renderCheckpoints(checkpoints)}
      </ProgressBarContainer>
    </MainContainer>
  );
};

const renderCheckpoints = (checkpointData) => {
  const checkpoints = [];
  for (let idx in checkpointData) {
    const checkpoint = checkpointData[idx];
    checkpoints.push(
      <Checkpoint
        progress={checkpoint.progress}
        isAchieved={checkpoint.isAchieved}
      >
        <CheckpointLabelContainer>
          <Typograph
            variant="subtitle2"
            dangerouslySetInnerHTML={{ __html: checkpoint.upperLabel }}
          />
          <Typograph
            variant="subtitle2"
            dangerouslySetInnerHTML={{ __html: checkpoint.lowerLabel }}
          />
        </CheckpointLabelContainer>
      </Checkpoint>
    );
  }
  return checkpoints;
};

const ProgressLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  height: 80px;
`;

const CheckpointLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  position: absolute;
  gap: 30px;
  left: 50%;
  bottom: 0;
  width: 150px;
  height: max-content;
  opacity: 80%;
  transform: translate(-50%, 28px);
`;

const Checkpoint = styled.div`
  left: max(calc(${(props) => props.progress}% - 24px), 0%);
  position: absolute;
  background-color: ${({ isAchieved }) =>
    isAchieved ? variables.green500 : variables.red500};
  border-color: white;
  border-width: 2px;
  border-style: solid;
  border-radius: 50%;
  height: 24px;
  width: 24px;
  overflow: visible;
`;

const ProgressBar = styled.div`
  position: absolute;
  border-radius: 50px;
  height: 12px;
  width: ${({ progress }) => progress + "%"};
  background-color: blue;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ProgressBarContainer = styled.div`
  flex: 1;
  border-radius: 50px;
  height: 12px;
  width: 100%;
  background-color: #e6e6e6;
  position: relative;
  display: flex;
  align-items: center;
`;

const MainContainer = styled.div`
  height: 100px;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export default CheckpointProgressBar;
